<template>
	<div>
		<!-- <DailyPopup /> -->
		<!-- 左侧导航栏 -->
		<LeftNav />
		<!-- 右侧顶部内容 -->
		<RightTop />
		<!-- 右侧内容 -->
		<HomeSearch />

		<div class="nav-body-list">
			<div class="nav-body-list-model" v-for="(item, index) in menu_list" :id="'section-' + item.node_id">
				<div class="nav-body-list-model-content">
					<div class="nav-body-list-model-title">
						<div class="title-left">
							<img class="nav-body-list-model-title-img" :src="item.icon_path" />
							{{ item.display_name }}
						</div>
						<div v-if="item.items && item.items.length > 18" class="title-more"
							@click="toggleExpand(index)">
							{{ item.isExpanded ? '收起' : '更多' }}
							<div class="title-more-dayu"> <img
									:src="item.isExpanded ? require('@/assets/menu-submenu-arrow-down.png') : require('@/assets/menu-submenu-arrow-down.png')"
									:class="{'rotate-arrow': item.isExpanded}" /></div>
						</div>
					</div>


					<div class="nav-body-list-model-content-line">

						<div @click="goDetail(item_children.item_id)" class="nav-body-list-model-content-line-model"
							v-for="item_children in item.isExpanded ? item.items : item.items.slice(0, 18)">
							<img class="nav-body-list-model-content-line-model-img" :src="item_children.logo_path" />
							<div class="nav-body-list-model-content-line-model-content">
								<div class="nav-body-list-model-content-line-model-content-title">
									{{item_children.display_name}}
								</div>
								<div class="nav-body-list-model-content-line-model-content-foot">
									{{item_children.description}}
								</div>
							</div>
						</div>
					</div>
				</div>


			</div>
			<div class="nav-footer">
				<div class="nav-footer-line-1">
					<div class="nav-footer-line-1-model">
						<img class="nav-footer-line-1-model-img" src="../assets/foot/logo2.png" />

					</div>
					<div class="nav-footer-line-1-power">Copyright © 灵研学术导航 皖ICP备2025074553号-3</div>
				</div>
				<div class="nav-footer-line-2">
					<div class="nav-footer-line-2-font">便捷学术导航平台，助力学术进阶</div>
					<div class="nav-footer-line-2-model">
						<div class="nav-footer-line-2-model-font" @click="gotoLink('About')">关于我们</div>
						<div class="nav-footer-line-2-model-font" @click="gotoLink('Disclaimers')">免责声明</div>
					</div>
				</div>
			</div>
		</div>


	</div>
</template>

<script>
	import request from '@/utils/request'
	import DailyPopup from './DailyPopup.vue';
	import LeftNav from './LeftNav.vue';
	import RightTop from './RightTop.vue';
	import HomeSearch from './HomeSearch.vue';
	export default {
		name: 'HomePage',
		components: {
			DailyPopup,
			LeftNav,
			RightTop,
			HomeSearch
		},


		data() {
			return {
				sources: [{
						name: '必应',
						img: require('../assets/search-img.png')
					},
					{
						name: '万方',
						img: require('../assets/search-img.png')
					},
					{
						name: '百度学术',
						img: require('../assets/search-img.png')
					},
					{
						name: 'X-MOL学术',
						img: require('../assets/search-img.png')
					},
					{
						name: 'PubMed',
						img: require('../assets/search-img.png')
					},
					{
						name: 'Github',
						img: require('../assets/search-img.png')
					},
					{
						name: '在线翻译',
						img: require('../assets/search-img.png')
					}
				],
				selectedSource: 0,
				indicatorLeft: 0,
				menu_list: [],
				search_source_list: [],
				activeId: null,
				searchText: '',
				more_show: false,
			};
		},
		created() {
			this.initNav()
		},
		mounted() {
			this.$nextTick(() => {
				this.updateIndicator2();
			});
		},
		methods: {
			selectSource(index) {
				this.selectedSource = index;
				this.$nextTick(() => {
					this.updateIndicator();
				});
			},
			updateIndicator() {
				const items = this.$refs.sourceItems;
				if (items && items[this.selectedSource]) {
					const el = items[this.selectedSource];
					console.log("this.el", this.selectedSource)
					// 使箭头居中于每个 source-item
					const iconWidth = 12; // 箭头宽度
					this.indicatorLeft = el.offsetLeft + (el.offsetWidth / 2) - (iconWidth / 2);
					console.log("this.indicatorLeft", this.indicatorLeft)

				}
			},
			updateIndicator2() {
				const items = this.$refs.sourceItems;
				if (items && items[this.selectedSource]) {
					const el = items[this.selectedSource];
					console.log("this.el", this.selectedSource)
					// 使箭头居中于每个 source-item
					const iconWidth = 12; // 箭头宽度
					this.indicatorLeft = el.offsetLeft + (el.offsetWidth / 2) - (iconWidth / 2) - 165;
					console.log("this.indicatorLeft", this.indicatorLeft)

				}
			},
			initNav() {
				request.get('/businessService/v1/navigation/menuNode/fetch', {
						// params: {
						// 	article_id: id
						// }
					})
					.then(res => {
						if (res.code = '000000') {
							console.log("initNav", res)
							this.menu_list = res.menu_nodes

							this.menu_list.forEach(item => {
								this.$set(item, 'isExpanded', false);
							});
							this.activeId = res.menu_nodes[0].node_id
						}

					})
					.catch(error => {
						console.error("获取导航列表失败:", error);
					});


			},
			goDetail(id) {
				console.log("goDetail", id)
				// this.$router.push({ name: 'NavDetail', params: { id } })
				this.$router.push({
					path: `/nav/${id}`
				})


			},
			gotoLink(url) {
				this.$router.push({
					name: url
				})


			},
			selectMenu(id) {
				this.activeId = id;
				// 页面平滑滚动到目标模块
				const target = document.getElementById(`section-${id}`);
				if (target) {
					target.scrollIntoView({
						behavior: 'smooth',
						block: 'start'
					});
				}
			},
			doSearch() {
				// 打印或处理搜索内容
				if (this.searchText.trim() === '') {
					alert('请输入搜索内容');
					return;
				}
				const source = this.sources[this.selectedSource];
				if (!source || !source.base_url) {
					alert('未选择有效的搜索源');
					return;
				}

				// 3. 拼接完整搜索地址（假设是 GET 请求，将关键词拼接在 URL 后面）
				const query = encodeURIComponent(this.searchText.trim());
				const fullUrl = `${source.base_url}${query}`;

				// 4. 在新标签页打开链接
				window.open(fullUrl, '_blank');


			},
			toggleExpand(index) {

				this.menu_list[index].isExpanded = !this.menu_list[index].isExpanded;
			},

		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.nav-body-list {
		/* Frame 427321189 */

		/* Auto layout */
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		padding: 0px;
		gap: 40px;

		position: absolute;
		width: calc(100% - 240px);
		/* height: 946px; */
		left: 240px;
		/* left: 260px; */
		top: 322px;
		padding: 0px 20px;
		box-sizing: border-box;
		/* background: #E8F3FF; */





	}

	.nav-body-list-model {
		/* Frame 427321186 */

		/* Auto layout */
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		padding: 0px;
		gap: 16px;

		width: 100%;
		/* height: 230px; */


		/* Inside auto layout */
		flex: none;
		order: 0;
		align-self: stretch;
		flex-grow: 0;

		/* background-color: #165DFF; */
	}

	.nav-body-list-model-title {
		/* Frame 427321183 */

		/* Auto layout */
		display: flex;
		justify-content: space-between;
		/* ✅ 左右分布 */
		align-items: center;
		/* ✅ 垂直居中关键 */


		padding: 0px;
		gap: 2px;

		/* width: 86px; */
		width: 100%;

		height: 22px;




		/* Inside auto layout */
		flex: none;
		order: 0;
		flex-grow: 0;
		/* 灵研推荐 */


		/* 16/Medium
		
		用于按钮等大多数操作类的文字
		*/
		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 500;
		font-size: 16px;
		line-height: 140%;
		/* or 22px */

		/* 文字/text-5 */
		color: #1D2129;
	}

	.title-left {
		display: flex;
		align-items: center;
		gap: 4px;
		/* 图标和文字间距 */
	}

	.title-more {
		color: #1D2129;
		font-size: 14px;
		cursor: pointer;

		/* 更多 */

		/* width: 28px; */
		height: 20px;

		/* 14/Regular
		
		用于多数次级文字
		*/
		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		line-height: 140%;
		/* identical to box height, or 20px */

		/* 文字/text-5 */
		color: #1D2129;

		display: flex;
		user-select: none;
		/* 标准语法 */
		-webkit-user-select: none;
		/* Chrome、Safari */
		-moz-user-select: none;
		/* Firefox */
		-ms-user-select: none;
		/* IE/Edge */



	}

	.title-more-dayu {
		/* Frame */

		width: 20px;
		height: 20px;


		/* Inside auto layout */
		flex: none;
		order: 1;
		flex-grow: 0;

	}

	.title-more-dayu img {
		/* Vector */

		width: 16px;
		height: 16px;
		transition: transform 0.3s ease-in-out;


	}


	.title-more-dayu img.rotate-arrow {
		transform: rotate(180deg);
	}


	.nav-body-list-model-title-img {
		/* Frame */

		width: 18px;
		height: 18px;


		/* Inside auto layout */
		flex: none;
		order: 0;
		flex-grow: 0;

	}

	.nav-body-list-model-content {
		/* Frame 3785 */

		/* Auto layout */
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		padding: 0px;
		gap: 16px;

		width: 100%;
		/* height: 192px; */


		/* Inside auto layout */
		flex: none;
		order: 1;
		align-self: stretch;
		flex-grow: 0;

		/* background-color: aliceblue; */

	}

	.nav-body-list-model-content-line {
		display: grid;
		gap: 16px;
		grid-template-columns: repeat(4, 1fr);
		/* 默认4列 */
		width: 100%;
		min-width: calc(278px * 4 + 16px * 3);
		max-width: calc(278px * 6 + 16px * 5);
		/* 卡片宽度 * 4 + 间距 */
		/* margin: 0 auto; */

	}

	@media (min-width: 1600px) {
		.nav-body-list-model-content-line {
			grid-template-columns: repeat(5, 1fr);
			min-width: calc(278px * 4 + 16px * 3);
			max-width: calc(278px * 8 + 16px * 7);
			/* 卡片宽度 * 6 + 间距 */
		}

		.nav-body-list-model-title {
			min-width: calc(278px * 4 + 16px * 3);
			max-width: calc(278px * 8 + 16px * 7);
		}
	}


	@media (min-width: 1900px) {
		.nav-body-list-model-content-line {
			grid-template-columns: repeat(5, 1fr);
			min-width: calc(278px * 4 + 16px * 3);
			max-width: calc(278px * 8 + 16px * 7);
			/* 卡片宽度 * 6 + 间距 */
		}

		.nav-body-list-model-title {
			min-width: calc(278px * 4 + 16px * 3);
			max-width: calc(278px * 8 + 16px * 7);
		}
	}

	@media (min-width: 2000px) {
		.nav-body-list-model-content-line {
			grid-template-columns: repeat(6, 1fr);
			min-width: calc(278px * 4 + 16px * 3);
			max-width: calc(278px * 8 + 16px * 7);
			/* 卡片宽度 * 6 + 间距 */
		}

		.nav-body-list-model-title {
			min-width: calc(278px * 4 + 16px * 3);
			max-width: calc(278px * 8 + 16px * 7);
		}
	}



	.nav-body-list-model-content-line-model {
		/* aspect-ratio: 278 / 88; */
		height: 88px;
		width: 100%;
		background: #fff;
		border-radius: 10px;
		padding: 20px 16px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		gap: 12px;
		transition: transform 0.3s ease;
		cursor: pointer;
		/* min-width: 0; */
		/* 防止卡片撑开 grid */
	}




	.nav-body-list-model-content-line-model:hover {
		z-index: 2;
		transform: translateY(-4px);
		box-shadow: 0px 4px 40px 0px #0000001A;
		/* 向上移动 4px */
	}

	.nav-body-list-model-content-line-model:hover .nav-body-list-model-content-line-model-content-title {
		color: #165DFF;
		/* 标题变蓝 */
	}

	.nav-body-list-model-content-line-model-img {
		/* Ellipse 147 */

		box-sizing: border-box;
		border-radius: 48px;
		width: 48px;
		height: 48px;
		border: 1px solid var(--border-1, #F2F3F5);

		/* 填充/fill-2
		
		常规/白底悬浮
		*/
		/* border: 0.5px solid #F2F3F5; */

		/* Inside auto layout */
		flex: none;
		order: 0;
		flex-grow: 0;

	}

	.nav-body-list-model-content-line-model-content {
		/* Frame 3780 */

		/* Auto layout */
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		padding: 0px;
		gap: 4px;

		width: 186px;
		height: 41px;


		/* Inside auto layout */
		flex: none;
		order: 1;
		flex-grow: 0;

	}

	.nav-body-list-model-content-line-model-content-title {
		/* 人工智能论文写作神奇 */

		/* width: 140px; */
		height: 20px;
		white-space: nowrap;
		/* 防止文本换行 */
		overflow: hidden;
		/* 隐藏溢出的内容 */
		text-overflow: ellipsis;
		/* 14/Medium */
		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 500;
		font-size: 14px;
		line-height: 140%;
		/* identical to box height, or 20px */

		/* 文字/text-5 */
		color: #1D2129;
		text-align: left;


		/* Inside auto layout */
		flex: none;
		order: 0;
		align-self: stretch;
		flex-grow: 0;

	}

	.nav-body-list-model-content-line-model-content-foot {
		/* 一键生成论文 */

		/* width: 186px; */
		height: 17px;
		white-space: nowrap;
		/* 防止文本换行 */
		overflow: hidden;
		/* 隐藏溢出的内容 */
		text-overflow: ellipsis;
		/* 显示省略号来代表被修剪的文本 */
		/* 12/Regular
		
		用于多数辅助信息类文字
		*/
		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 400;
		font-size: 12px;
		line-height: 140%;
		/* identical to box height, or 17px */

		/* 文字/text-3 */
		color: #86909C;


		/* Inside auto layout */
		flex: none;
		order: 1;
		align-self: stretch;
		flex-grow: 0;

		text-align: left;

	}

	.nav-footer {
		/* Frame 427321195 */

		/* Auto layout */
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		padding: 24px 40px;
		box-sizing: border-box;
		gap: 20px;

		width: 100%;
		height: 136px;

		background-color: #FFFFFF;

		/* 	position: absolute;
		left: 0;
		bottom: 0; */

		border-radius: 12px;

		/* Inside auto layout */
		flex: none;
		order: 3;
		flex-grow: 0;
		margin-bottom: 23px;
	}

	.nav-footer-line-1 {
		/* Frame 427321193 */

		/* Auto layout */
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		padding: 0px;
		gap: 681px;

		min-width: 1080px;
		height: 48px;


		/* Inside auto layout */
		flex: none;
		order: 0;
		align-self: stretch;
		flex-grow: 0;



	}

	.nav-footer-line-2 {
		/* Frame 427321194 */

		/* Auto layout */
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		padding: 0px;
		gap: 744px;

		min-width: 1080px;
		height: 20px;


		/* Inside auto layout */
		flex: none;
		order: 1;
		align-self: stretch;
		flex-grow: 0;

		/* background-color: #A0AEC0; */

	}

	.nav-footer-line-1-model {
		/* Frame 427321192 */

		/* Auto layout */
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 0px;
		gap: 11px;

		width: 123px;
		height: 48px;


		/* Inside auto layout */
		flex: none;
		order: 0;
		flex-grow: 0;

	}

	.nav-footer-line-1-model-img {
		/* Frame 427321192 */

		/* Auto layout */
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 0px;
		gap: 11px;

		width: 123px;
		height: 48px;


		/* Inside auto layout */
		flex: none;
		order: 0;
		flex-grow: 0;

	}

	.nav-footer-line-1-power {
		/* 版权所有@2025 灵研学术导航 皖ICP备1239345号 */

		/* width: 271px; */
		height: 17px;

		/* 12/Regular
		
		用于多数辅助信息类文字
		*/
		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 400;
		font-size: 12px;
		line-height: 140%;
		/* identical to box height, or 17px */

		/* 文字/text-4 */
		color: #4E5969;


		/* Inside auto layout */
		flex: none;
		order: 1;
		flex-grow: 0;

	}

	.nav-footer-line-2-font {
		/* 便捷学术导航平台，助力学术进阶 */

		width: 210px;
		height: 20px;

		/* 14/Regular
		
		用于多数次级文字
		*/
		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		line-height: 140%;
		/* identical to box height, or 20px */

		/* 文字/text-5 */
		color: #1D2129;


		/* Inside auto layout */
		flex: none;
		order: 0;
		flex-grow: 0;

	}

	.nav-footer-line-2-model {
		/* Frame 427321190 */

		/* Auto layout */
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 0px;
		gap: 12px;

		width: 120px;
		height: 17px;


		/* Inside auto layout */
		flex: none;
		order: 1;
		flex-grow: 0;

	}

	.nav-footer-line-2-model-font {
		/* 免责声明 */

		width: 48px;
		height: 17px;

		/* 12/Regular
		
		用于多数辅助信息类文字
		*/
		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 400;
		font-size: 12px;
		line-height: 140%;
		/* identical to box height, or 17px */

		/* 文字/text-5 */
		color: #1D2129;


		/* Inside auto layout */
		flex: none;
		order: 2;
		flex-grow: 0;
		user-select: none;
		/* 标准语法 */
		-webkit-user-select: none;
		/* Chrome、Safari */
		-moz-user-select: none;
		/* Firefox */
		-ms-user-select: none;
		/* IE/Edge */

	}

	.nav-footer-line-2-model-font:hover {
		cursor: pointer;
	}
</style>